import ExpandMore from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import { HistoryDecisionType } from '@/data/subsidy/interfaces';
import { DescriptionContent } from '@/packages/subsidy-management/components/description-content';
import type { DetailsProps } from '@/packages/subsidy-management/interfaces';

const variantType = {
  [HistoryDecisionType.Reject]: 'error',
  [HistoryDecisionType.Canceled]: 'error',
  [HistoryDecisionType.RevisionRequires]: 'warning',
  [HistoryDecisionType.Approved]: 'success',
  default: 'default',
} as const;

export const Description = ({ resourceApprovalsDetails }: DetailsProps) => {
  const institutionName =
    resourceApprovalsDetails?.resource?.course?.institution_name;
  const resourceName = resourceApprovalsDetails?.name?.split(', ')[0];
  const displayName = [resourceName, institutionName]
    .filter(Boolean)
    .join(' | ');
  const lastHistoryEntry = resourceApprovalsDetails?.history?.at(-1);
  const chipColor =
    lastHistoryEntry &&
    (variantType[lastHistoryEntry.decision] ?? variantType.default);

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Stack gap={2} alignItems="start">
          <Typography variant="h2" mb={1} color="primary.dark">
            Descrição do item
          </Typography>
          <Typography>{displayName}</Typography>
          {lastHistoryEntry && (
            <Chip label={lastHistoryEntry.message} color={chipColor} />
          )}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <DescriptionContent
          resourceApprovalsDetails={resourceApprovalsDetails}
        />
      </AccordionDetails>
    </Accordion>
  );
};
